
const digest = 'e20ef72fff3189944b0bc67cce3e99539512117d15a2eccbfe8a693ac22a3db8';
const classes = {"wrapper":"_wrapper_8zo2a_1","title":"_title_8zo2a_10","controls":"_controls_8zo2a_14"};
const css = `._wrapper_8zo2a_1 {
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  background: #ffffff;
  border: 1px solid #eaedf3;
  padding: 24px;
}
._wrapper_8zo2a_1 ._title_8zo2a_10 {
  flex-grow: 1;
  font-size: 14px;
}
._wrapper_8zo2a_1 ._controls_8zo2a_14 {
  display: flex;
  flex-direction: row;
  gap: 12px;
  min-width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  